import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

export const WriterlyAuthWordsCarousel = ({
  words,
  timer = 1500,
  autoRotate,
  manualRotate,
  fixedWord,
}) => {
  words = [...words, ...words];

  const [currentWord, setCurrentWord] = useState(0);
  const middle = Math.ceil(words.length / 2);
  const itemHeight = 140;
  const baseHeight = 290;
  const maxContent = itemHeight + baseHeight;
  const fixedWordHeight = maxContent * 0.92;
  const visible = middle * itemHeight;

  useEffect(() => {
    const interval =
      autoRotate &&
      setInterval(() => {
        moveWord();
      }, timer);
    return () => {
      autoRotate && clearInterval(interval);
    };
  }, []);

  const calculatePosition = (wordIndex) => {
    const base = baseHeight;
    if (currentWord === wordIndex) return base;

    if (wordIndex >= middle) {
      if (currentWord > wordIndex - middle) {
        return (wordIndex - currentWord) * itemHeight + base;
      } else {
        return -(words.length + currentWord - wordIndex) * itemHeight + base;
      }
    }

    if (wordIndex > currentWord) {
      return (wordIndex - currentWord) * itemHeight + base;
    }

    if (wordIndex < currentWord) {
      if ((currentWord - wordIndex) * itemHeight >= visible) {
        return (words.length - (currentWord - wordIndex)) * itemHeight + base;
      }
      return -(currentWord - wordIndex) * itemHeight + base;
    }
  };

  const moveWord = () => {
    setCurrentWord((prevWord) => {
      if (prevWord + 1 > words.length - 1) {
        return 0;
      }
      return prevWord + 1;
    });
  };

  return (
    <div className="w-full h-full">
      <div className="h-full flex justify-end overflow-hidden">
        {fixedWord && (
          <div
            className="text-[70px] text-white font-normal xl:text-[90px] mr-5"
            style={{
              transform: `translateY(${fixedWordHeight}px)`,
            }}
          >{`${fixedWord} `}</div>
        )}

        <div className="relative w-3/5 h-screen max-h-screen mt-[-20px]">
          {words.map((word, i) => (
            <div
              onClick={() => {
                manualRotate && !autoRotate && setCurrentWord(i);
              }}
              className={`absolute top-[130px] ${
                currentWord === i
                  ? `transition-all duration-300 ease-in-out ${
                      !fixedWord && 'ml-[-25%]'
                    } opacity-100`
                  : `transition-all duration-300 ease-in-out ${
                      !fixedWord && 'ml-0'
                    } opacity-50 mr-auto `
              } ${
                calculatePosition(i) > baseHeight + maxContent ||
                calculatePosition(i) < baseHeight - maxContent
                  ? '!opacity-0'
                  : ''
              } w-[100vh]`}
              key={i}
              style={{
                transform: `translateY(${calculatePosition(i)}px)`,
              }}
            >
              <span className="text-[70px] text-white font-normal xl:text-[90px]">
                {word}
                {currentWord === i && (
                  <span className="absolute ml-10 mt-1 xl:mt-5 animate-blinkingCursor border-solid border-[2px] border-white h-[78px] w-[1px]"></span>
                )}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

WriterlyAuthWordsCarousel.propTypes = {
  words: PropTypes.array.isRequired,
  fixedWord: PropTypes.string,
  timer: PropTypes.number,
  autoRotate: PropTypes.bool,
  manualRotate: PropTypes.bool,
};
